const mixinIndexTab = {
  methods: {
    cotentLoading(show) {
      this.$emit('cotentLoading', show ? show : false);
    },
    notifyVue(data) {
      this.$emit('showNotification', data);
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      let menu = JSON.parse(sessionStorage.getItem('levelThree'));
      if (oldTab.tabId != newTab.tabId) {
        this.$router.push('/' + menu[tabIndex].url);
        sessionStorage.setItem('urlModule', '/' + menu[tabIndex].url);
      }
    },
    getMenuFromSessionStorage() {
      let menu = [];
      try {
        menu = Object(JSON.parse(sessionStorage.getItem('levelThree')));
      } catch (error) {}

      return menu;
    },
    setUpdated(ref) {
      let menu = this.getMenuFromSessionStorage();

      if (menu.length <= 0) {
        this.$router.push('/notaccess');
        this.cotentLoading(false);
      } else {
        for (let index = 0; index < menu.length; index++) {
          const element = menu[index];
          if (this.$route.path === '/' + element.url) {
            try {
              ref.activeTabIndex = element.order;
            } catch (error) {
              ref.activeTabIndex = index;
            }
            break;
          }
        }
      }
    },
    setMounted(ref) {
      let menu = this.getMenuFromSessionStorage();

      if (menu.length <= 0) {
        this.$router.push('/notaccess');
        this.cotentLoading(false);
      } else {
        for (let index = 0; index < menu.length; index++) {
          const element = menu[index];
          if ('/' + element.url == this.$route.path) {
            try {
              ref.activeTabIndex = element.order;
            } catch (error) {
              ref.activeTabIndex = index;
            }
            break;
          }
        }
      }
    },
    setDestroyed() {
      sessionStorage.removeItem('levelThree');
    },
    setActiveTab(data) {
      const { ref, index } = data;
      try {
        this.$refs[ref].findTabAndActivate(index);
      } catch (error) {}
    },
  },
};

export default mixinIndexTab;
